import Const from 'constants';
import {combineReducers} from 'redux';
import {generateSignature} from 'helpers/hash';

class State {
    signature;
    constructor(signature = null) {
        this.signature = signature;
    }
    getSignature = () => this.signature;
}

const defaultState = new State();

export function settings(state = defaultState, action) {
    if (action.type === Const.RESET_ALL_SETTINGS) {
        state = new State(generateSignature());
    }

    return state;
}

const reducers = {
    settings,
};

export default combineReducers(reducers);
